// extracted by mini-css-extract-plugin
export default {"container":"Nba-z","heading":"Oba-z","links":"Pba-z","linkBtn":"Qba-z","disabled":"Rba-z","linkUppercaseBold":"Sba-z","copy":"Tba-z","subCopy":"Uba-z"};